import type {
  PlaybookCriterionNode,
  PlaybookId,
} from "@repo/app-types/entities/playbook";
import type { TeammateId } from "@repo/app-types/entities/teammate";
import type { FC } from "react";
import { usePlaybookCriterionTopExamplesQuery } from "../../api/entities/performancePlaybook.js";
import { CriterionTeamExamplesView } from "./criterionTeamExamples.js";

interface CriterionTeamExamplesContainerProps {
  playbookId: PlaybookId;
  teammateId: TeammateId;
  criterion: PlaybookCriterionNode;
}

export const CriterionTeamExamplesContainer: FC<
  CriterionTeamExamplesContainerProps
> = (props) => {
  const { playbookId, teammateId, criterion } = props;

  // currentData only includes results for these args, so switching criteria or
  // teammates does not briefly show examples from the previous selection.
  const { currentData: topExamples } = usePlaybookCriterionTopExamplesQuery({
    playbookId,
    criterionId: criterion.id,
    excludeTeammateId: teammateId,
  });

  return (
    <CriterionTeamExamplesView
      playbookId={playbookId}
      criterion={criterion}
      sortedGradings={topExamples ?? []}
    />
  );
};
